export const actions = {
    FETCH: 'FETCH',
    LOADING: 'LOADING'
}